import axios from "./axiosInstance";

// Fetch all events
export async function fetchAllEvents() {
  const res = await axios.get("/admin/events");
  return res.data;
}

// Fetch all users
export async function fetchAllUsers() {
  const res = await axios.get("/admin/users");
  return res.data;
}

// Fetch pending events
export async function fetchPendingEvents() {
  const res = await axios.get("/admin/events/pending");
  return res.data;
}

// Fetch events for history (approved or past unapproved)
export async function fetchEventsForHistory() {
  const res = await axios.get("/admin/events/history");
  return res.data;
}

// Fetch event details by ID
export async function fetchEventDetails(eventId) {
  const res = await axios.get(`/admin/event/${eventId}`);
  return res.data;
}

// Approve/Reject event
export async function updateEventStatus(eventId, status, comment = "") {
  const res = await axios.put(`/admin/event/${eventId}/status`, { status, comment });
  return res.data;
}

// Enable/disable an event on the event menu (Disabled flag)
export async function setEventDisabled(eventId, disabled) {
  const res = await axios.put(`/admin/event/${eventId}/disabled`, { disabled });
  return res.data;
}

// Update editable event fields
export async function updateEventDetails(eventId, fields) {
  const res = await axios.put(`/admin/events/${eventId}`, fields);
  return res.data;
}

// Toggle user active/disabled
export async function toggleUserStatus(userId, currentStatus) {
  const res = await axios.post("/admin/toggle-user-status", { userId, currentStatus });
  return res.data;
}

// Users with/without events
export async function fetchUsersWithEvents() {
  const res = await axios.get("/admin/users-with-events");
  return res.data;
}

export async function fetchUsersWithoutEvents() {
  const res = await axios.get("/admin/users-without-events");
  return res.data;
}

// Fetch user profile by ID
export async function fetchUserProfile(userId) {
  const res = await axios.get(`/admin/user-profile/${userId}`);
  return res.data;
}

// Fetch user ticket purchases by ID
export async function fetchUserTicketPurchases(userId, all = false) {
  const res = await axios.get(`/admin/user-ticket-purchases/${userId}${all ? '?all=true' : ''}`);
  return res.data;
}

// Fetch events by user ID
export async function fetchEventsByUserId(userId) {
  const res = await axios.get(`/admin/events-by-user/${userId}`);
  return res.data;
}

export async function fetchUserGrowthAnalytics() {
  const res = await axios.get('/admin/analytics/user-growth');
  return res.data;
}

export async function fetchEventPerformanceAnalytics() {
  const res = await axios.get('/admin/analytics/event-performance');
  return res.data;
}

export async function fetchGeographicEventDistribution() {
  const res = await axios.get('/admin/analytics/geographic-distribution');
  return res.data;
}
